<template>
  <div class="teaching-arrange-setting-main"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="detailInfo">
      <div class="side">
        <div class="header">
          <div class="title">
            <span>教学点（{{getSites ? getSites.length : 0}}）</span>
          </div>
          <div class="empty">
            <el-radio-group v-model="form.current">
              <el-radio-button label="">
                <i class="el-icon-setting"></i>
                <span>默认配置</span>
              </el-radio-button>
            </el-radio-group>
          </div>
          <div class="input">
            <el-input v-model="form.keyword"
                      size="mini"
                      type="text"
                      clearable
                      placeholder="搜索关键字..."></el-input>
          </div>
        </div>
        <div class="body">
          <div class="body-cont">
            <template v-if="getSites && getSites.length">
              <AppScrollbar style="height: 100%">
                <div class="site-list">
                  <el-radio-group v-model="form.current">
                    <el-radio-button class="theme-light-bg-active theme-text-active theme-border-active"
                                     v-for="site in getSites"
                                     :key="site.id"
                                     :label="site.id">
                      <div class="label">
                        <span>{{site.name}}</span>
                      </div>
                      <div class="extra">
                        <el-tag v-if="site.configured"
                                size="mini"
                                type="primary">已设置</el-tag>
                        <el-tag v-else
                                size="mini"
                                type="info">未设置</el-tag>
                      </div>
                    </el-radio-button>
                  </el-radio-group>
                </div>
              </AppScrollbar>
            </template>
            <template v-else>
              <Hint type="empty">
                <div v-if="form.keyword">没有匹配的教学点</div>
                <div v-else>没有可配置教学点</div>
              </Hint>
            </template>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="main-cont">
          <keep-alive>
            <component :key="form.current"
                       :is="getComponent"
                       :site="getCurrent"
                       v-bind="detailInfo"
                       @configure-change="onConfigureChange"></component>
          </keep-alive>
        </div>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>配置数据加载失败</div>
        <el-button type="text"
                   @click="loadDetailInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../elements/AppScrollbar'
import TeachingArrangeSettingConfigure from './configure'
import TeachingArrangeSettingConfigureCustom from './configure/custom'
import Hint from '../../../../../../elements/Hint'
export default {
  name: 'TeachingArrangeSettingMain',
  components: {
    AppScrollbar,
    Hint
  },
  data () {
    return {
      loading: false,
      detailInfo: null,
      form: {
        keyword: '',
        current: ''
      }
    }
  },
  computed: {
    getSites () {
      const detailInfo = this.detailInfo
      if (detailInfo) {
        let sites = detailInfo.sites
        if (sites) {
          const keyword = this.form.keyword
          if (keyword) {
            sites = sites.filter(site => (site.name || '').includes(keyword))
          }
          return sites
        }
      }
    },
    getCurrent () {
      const current = this.form.current
      if (current) {
        const detailInfo = this.detailInfo
        if (detailInfo) {
          let sites = detailInfo.sites
          if (sites) {
            return sites.find(site => site.id === current)
          }
        }
      }
    },
    getComponent () {
      if (this.getCurrent) {
        return TeachingArrangeSettingConfigureCustom
      } else {
        return TeachingArrangeSettingConfigure
      }
    }
  },
  methods: {
    loadDetailInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/setting/arrange/detailInfo',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.detailInfo = response.data['detailInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    onConfigureChange (siteId, configured) {
      const detailInfo = this.detailInfo
      if (detailInfo) {
        let sites = detailInfo.sites
        if (sites) {
          let site = sites.find(site => site.id === siteId)
          if (site) {
            this.$set(site, 'configured', configured)
          }
        }
      }
    }
  },
  mounted () {
    this.loadDetailInfo()
  }
}
</script>

<style lang="scss">
  .teaching-arrange-setting-main {
    height: 100%;
    display: flex;
    align-items: stretch;
    & > .side {
      flex: none;
      width: 220px;
      display: flex;
      flex-direction: column;
      border-right: 1px solid #ebeef5;
      & > .header {
        flex: none;
        padding: 10px;
        & > .title {
          color: #303133;
          font-size: 12px;
          font-weight: bold;
          padding-left: 2px;
        }
        & > .empty {
          margin-top: 10px;
          .el-radio-group {
            display: block;
            .el-radio-button {
              display: block;
              .el-radio-button__inner {
                display: block;
                border-radius: 20px;
                padding: 7px 10px;
              }
            }
          }
        }
        & > .input {
          margin-top: 10px;
          .el-input {
            .el-input__inner {
              background-color: #f9f9f9;
              border-radius: 20px;
            }
          }
        }
      }
      & > .body {
        flex: auto;
        position: relative;
        & > .body-cont {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          .site-list {
            .el-radio-group {
              display: block;
              .el-radio-button {
                display: block;
                border-left: 2px solid transparent;
                .el-radio-button__inner {
                  border: none;
                  box-shadow: none;
                  border-radius: 0;
                  color: unset;
                  text-align: unset;
                  padding: 10px;
                  background-color: unset;
                  display: flex;
                  align-items: center;
                  & > .label {
                    flex: auto;
                  }
                  & > .extra {
                    margin-left: 5px;
                    flex: none;
                    .el-tag {
                      margin-top: -4px;
                      margin-bottom: -4px;
                    }
                  }
                }
                & + .el-radio-button {
                  margin-top: 1px;
                }
              }
            }
          }
        }
      }
    }
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
</style>
